<template>
  <v-container fluid class="full-container d-flex flex-column">
    <v-row>
      <v-col cols="12">
        <v-card class="secondary--text" min-height="100">
          <v-row>
            <v-col cols="4" class="pb-0">
              <v-card-title v-if="user">
                <v-avatar size="35" color="error" class="align-self-center">
                  <img v-if="user.userProfile.profilePicture" :src="user.userProfile.profilePicture" />
                  <span v-else class="white--text headline">{{ `${user.firstName[0]} ${user.lastName[0]}` }}</span>
                </v-avatar>

                <h3 class="ml-2 font-weight-regular">{{ user.firstName }}'s Tasks</h3>
              </v-card-title>
              <v-card-title class="py-0" v-if="myUsers">
                <span class="mr-2">
                  <v-icon color="secondary" class="mb-2">mdi-calendar</v-icon>
                  <span class="ml-1 navy--text">{{ $moment() | moment("ddd, D MMM") }}</span>
                </span>
                <span class="mx-3">
                  <v-icon color="secondary" class="mb-2 mr-1">mdi-account-group</v-icon>
                  {{ myUsers.activeClients }}
                </span>
                <span class="mx-3">
                  <v-icon color="secondary" class="mb-2">mdi-circle-outline</v-icon>
                  {{ myUsers.tasksOutstanding }}
                </span>
                <span class="mx-3">
                  <v-icon color="green" class="mb-2">mdi-check-circle-outline</v-icon>
                  {{ myUsers.tasksCompleted }}
                </span>
              </v-card-title>
            </v-col>
            <v-col cols="8" class="mt-0 pt-0">
              <v-row justify="end" class="px-4 pt-0">
                <v-col cols="4" class="pt-0">
                  <v-text-field v-model="search" label="Client name" />
                  <v-select
                    v-model="viewOption"
                    :items="taskOptions"
                    label="Show options"
                    single-line
                    dense
                    chips
                    clearable
                  />
                  <v-select
                    v-model="selectedCorporateChallenges"
                    :items="corporateChallenges"
                    label="Corporate challenges"
                    single-line
                    dense
                    chips
                    multiple
                  />
                </v-col>
                <v-col cols="4" class="pt-1">
                  <v-select
                    v-model="selectedTypes"
                    :items="taskTypes"
                    label="Task types"
                    single-line
                    dense
                    chips
                    multiple
                  />
                  <v-select
                    v-model="selectedProducts"
                    :items="['CLUB', 'ONE_ON_ONE']"
                    label="Product type"
                    single-line
                    dense
                    chips
                    multiple
                  />
                  <v-switch
                    v-model="showAllUserTasks"
                    label="Show all tasks for a user"
                    color="success"
                    class="mt-3"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1 fill-height overflow-auto">
      <v-col cols="3" sm="2" class="fill-height overflow-auto d-flex flex-column">
        <div class="d-flex justify-space-between">
          <h2 class="grey-navy--text ml-3 mb-3">
            {{ filteredList.length }} Client{{ filteredList.length != 1 ? "s" : "" }}
          </h2>
          <div class="d-flex">
            <v-switch v-model="showAll" class="mt-0" color="success" hide-details>
              <template v-slot:label>
                <v-icon color="success">mdi-check-circle-outline</v-icon>
              </template>
            </v-switch>
            <v-switch v-model="showSnoozed" class="mt-0 mx-1" color="success" hide-details>
              <template v-slot:label>
                <v-icon color="selection">mdi-calendar</v-icon>
              </template>
            </v-switch>
          </div>
        </div>
        <v-sheet rounded class="flex-grow-1">
          <v-card class="overflow-auto" elevation="0">
            <div v-for="taskEvent in myUsers.tasksWithNoUser" :key="taskEvent.id">
              <task-event-listing-card
                :task-event="taskEvent"
                :selected-event="selectedEvent"
                @select="selectedEvent = $event"
              />
            </div>

            <div v-for="user in filteredList" :key="user.id">
              <v-hover
                v-if="(user.userProfile && user.userProfile.incompleteTasks > 0) || viewOption"
                v-slot="{ hover }"
              >
                <v-card
                  class="mx-auto mb-3 fake-link"
                  :elevation="selectedUserId == user.id || hover ? 6 : 0"
                  :class="cardClasses(user)"
                  tile
                  @click="setSelectUser(user)"
                >
                  <v-card-text class="d-flex justify-space-between">
                    <h2 :class="selectedUserId == user.id ? 'navy--text' : 'font-weight-regular grey-navy--text'">
                      {{ `${user.firstName} ${user.lastName}` }}
                    </h2>
                    <div class="d-flex ">
                      <v-tooltip v-if="user.userProfile.atRiskOnboarding" right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" class="mb-3" color="red">mdi-exclamation-thick</v-icon>
                        </template>
                        <span>
                          Client has not contacted coach and submitted 2 workouts.
                        </span>
                      </v-tooltip>

                      <engagement-score-circle :engagement-score="user.userProfile.engagementScore" />
                      <span class="title block mx-2  black--text">{{ user.userProfile.incompleteTasks }}</span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-hover>
            </div>
          </v-card>
        </v-sheet>
      </v-col>
      <v-col v-if="selectedEvent" cols="6" class="fill-height overflow-auto">
        <task-details :task="selectedEvent" />
      </v-col>
      <v-col cols="6" class="fill-height overflow-auto">
        <user-tasks
          v-if="selectedUserId"
          :userId="selectedUserId"
          :assignedToId="userId"
          :showCompleted="showAll"
          :showSnoozed="showSnoozed"
          :types="selectedTypes"
          :showAllUserTasks="showAllUserTasks"
        />
      </v-col>
      <v-col cols="3" sm="4" class="fill-height overflow-auto d-flex flex-column">
        <v-sheet rounded class="flex-grow-1">
          <client-summary v-if="selectedUserId" :userId="selectedUserId" />
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { MY_USERS_QUERY, TASK_TYPE_QUERY } from "@/graphql/queries/task";
import { ACCOUNT_QUERY } from "@/graphql/queries/user";
import UserTasks from "@/components/task/components/UserTasks";
import ClientSummary from "@/components/task/components/ClientSummary";
import { CORPORATE_QUERY } from "@/graphql/queries/corporate";
import EngagementScoreCircle from "@/components/shared/EngagementScoreCircle";
import TaskEventListingCard from "@/components/task/components/TaskEventListingCard";
import TaskDetails from "@/components/task/components/TaskDetails";

export default {
  name: "TaskBase",
  props: ["userId"],
  components: {
    UserTasks,
    ClientSummary,
    EngagementScoreCircle,
    TaskEventListingCard,
    TaskDetails,
  },
  data() {
    return {
      myUsers: [],
      selectedUserId: this.$route.query.uid,
      showSnoozed: false,
      showCompleted: false,
      selectedTypes: [],
      showAll: false,
      me: null,
      search: "",
      viewOption: false,
      selectedProducts: [],
      showAllUserTasks: false,
      taskOptions: [
        { text: "My Clients", value: "my_clients" },
        { text: "Assigned tasks", value: "assigned_tasks" },
        { text: "All tasks", value: "all" },
      ],
      corporateChallenges: [],
      selectedCorporateChallenges: [],
      selectedEvent: null,
    };
  },
  watch: {
    userId: function() {
      this.myUsers = [];
      this.selectedUserId = null;
    },
  },
  computed: {
    filteredList() {
      if (!this.myUsers.users) {
        return [];
      }

      var users = this.myUsers.users;

      if (this.viewOption) {
        if (this.viewOption === "my_clients") {
          users = users.filter((val) => {
            return val.userProfile.activeSubscription?.coach?.id === this.userId;
          });
        }
        if (this.viewOption === "assigned_tasks") {
          users = users.filter((val) => {
            return (
              val.userProfile.activeSubscription?.coach == null ||
              val.userProfile.activeSubscription?.coach?.id !== this.userId
            );
          });
        }
      }

      return users.filter((user) => {
        return (
          (user.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
            user.lastName.toLowerCase().includes(this.search.toLowerCase()) ||
            `${user.firstName.toLowerCase()} ${user.lastName.toLowerCase()}`.includes(this.search.toLowerCase())) &&
          (this.selectedProducts.length == 0 ||
            (user.userProfile.activeSubscription &&
              this.selectedProducts.includes(user.userProfile.activeSubscription.product.type)))
        );
      });
    },
  },
  methods: {
    setSelectUser(user) {
      this.selectedUserId = user.id;
      this.selectedEvent = null;
    },
    cardClasses(user) {
      let classes = [];
      if (user.id == this.selectedUserId) {
        classes.push("user-selected");
      }

      if (user.userProfile.activeSubscription && user.userProfile.activeSubscription.product.type) {
        if (user.userProfile.activeSubscription.product.type == "CLUB") {
          classes.push("club-border");
        }
        if (user.userProfile.activeSubscription.product.type == "ONE_ON_ONE") {
          classes.push("one-on-one-border");
        }
        if (user.userProfile.activeSubscription.product.type == "JEFF_MEMBER") {
          classes.push("life-border");
        }
        if (user.userProfile.activeSubscription.corporateChallenge) {
          classes.push("corporate-border");
        }
      }

      return classes;
    },
  },
  apollo: {
    myUsers: {
      query: MY_USERS_QUERY,
      variables() {
        return {
          assigneeId: this.userId,
          taskTypes: this.selectedTypes,
          showSnoozed: this.showSnoozed,
          showAllClients: this.viewOption ? true : false,
          corporateChallenges: this.selectedCorporateChallenges,
        };
      },
      fetchPolicy: "cache-and-network",
    },
    user: {
      query: ACCOUNT_QUERY,
      variables() {
        let encoded_json_payload = btoa("UserNode:" + this.userId);
        return {
          userId: encoded_json_payload,
        };
      },
      fetchPolicy: "cache-and-network",
    },
    taskTypes: {
      query: TASK_TYPE_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.taskTypes.map((item) => {
          return {
            text: item.title,
            value: item.id,
          };
        });
      },
    },
    corporateChallenges: {
      query: CORPORATE_QUERY,
      fetchPolicy: "cache-and-network",
      update(data) {
        return data.corporateChallenges.map((cc) => {
          return {
            text: cc.title,
            value: cc.id,
          };
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.full-container {
  height: calc(100vh - 45px);
}

.club-border {
  border-left: 8px solid var(--v-club-base);
}
.one-on-one-border {
  border-left: 8px solid var(--v-one-on-one-base);
}

.life-border {
  border-left: 8px solid var(--v-jeff-life-base);
}
.corporate-border {
  border-left: 8px solid var(--v-sleep-base);
}
</style>
